<template>
  <div class="ine-card invoice">
    <div :class="['pill', `pill--${invoiceStateClass}`]">
      {{ invoiceState }}
    </div>
    <div class="invoice__details">
      <p class="invoice__label">{{ invoicePlanLabel }}</p>
      <p class="invoice__detail">{{ getDate(invoice.date) }}</p>
      <p class="invoice__detail">{{ invoiceTotal }}</p>
    </div>
    <div v-if="isLoading" class="invoice__loader">
      <ActionLoader :size="0.5" />
    </div>
    <button
      v-else
      @click="handleInvoiceDownload(invoice.number)"
      class="invoice__dl-btn"
    >
      <DownloadIcon class="dashboard__action-icon" />
    </button>
  </div>
</template>

<script>
import { formatSubDate } from '@/helpers'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import { DownloadIcon } from 'vue-feather-icons'
import CONSTANTS from '@/constants'

export default {
  name: 'Invoice',
  components: {
    ActionLoader,
    DownloadIcon,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    invoiceState() {
      const invoiceState = this.invoice.state
      const isAccountCredit = this.invoice.products?.length === 0
      if (isAccountCredit || ['closed', 'paid'].includes(invoiceState))
        return 'completed'
      if (['processing', 'pending', 'opened'].includes(invoiceState))
        return 'processing'
      if (['failed', 'voided'].includes(invoiceState)) return 'failed'
      if (['past_due'].includes(invoiceState)) return 'past due'
      return ''
    },
    invoiceStateClass() {
      return this.invoiceState === 'past due' ? 'past-due' : this.invoiceState
    },
    invoicePlanLabel() {
      const plans = this.invoice.products
      if (!plans || plans.length === 0) return 'Account Credit'
      let planLabels = ''
      plans.forEach(plan => {
        const planLabel = CONSTANTS.PLAN_LABELS[plan]
        planLabels += planLabel && `${CONSTANTS.PLAN_LABELS[plan]}, `
      })
      return planLabels.slice(0, -2)
    },
    invoiceTotal() {
      const invoiceTotal = this.invoice?.total
      if (!invoiceTotal) return '$0.00'
      return invoiceTotal > 0
        ? `$${invoiceTotal.toFixed(2)}`
        : `-$${Math.abs(invoiceTotal).toFixed(2)}`
    },
  },
  methods: {
    getDate(date) {
      return formatSubDate(date)
    },
    async handleInvoiceDownload(id) {
      this.isLoading = true
      await this.$store.dispatch('subscriptions/downloadInvoice', id)
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
.invoice {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin-bottom: 10px;
  height: 64px;
  cursor: pointer;
  @include mobile {
    height: 56px;
  }
  &:hover {
    background: var(--glass-extra-light);
    .dashboard__action-icon {
      border-color: var(--white);
    }
  }
  &__label {
    font-size: rem(14);
    line-height: 20px;
    color: var(--white);
    margin: 0;
    @include mobile {
      flex: 0 1 50%;
    }
  }
  &__loader {
    display: flex;
    align-items: center;
    max-height: 25px;
    .action-loader {
      display: flex;
    }
  }
  &__dl-btn {
    display: flex;
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    margin-left: auto;
    padding: 0;
    @include mobile {
      text-decoration: none;
    }
  }
  &__details {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    @include mobile {
      flex: 0 1 80%;
      flex-direction: row;
      align-items: center;
    }
  }
  &__detail {
    color: var(--light-blue-gray);
    font-size: rem(12);
    line-height: 14px;
    margin: 0;
    padding: 0;
    margin-left: 0;
    @include mobile {
      flex: 0 1 25%;
    }
  }
}
</style>
